
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import ExecucaoPlano from "components/qualidade/ExecucaoPlano";
import ReportEdit from "components/reports/ReportEdit";
import dayjs from "dayjs";
import saveAs from 'file-saver';
import Produto from "model/administracao/cadastro/produto/Produto";
import ComponenteOP from "model/producao/ComponenteOP";
import EstagioOP from "model/producao/EstagioOP";
import OrdemProducao from 'model/producao/OrdemProducao';
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Row } from "primereact/row";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import OrdemProducaoService from 'service/producao/OrdemProducaoService';
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";
import { converterDataHora } from "utils/convert";

const ordemProducaoService = new OrdemProducaoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function OrdemProducaoCadastro() {

    const { startLoading, stopLoading } = useLoadingContext();

    const [queryParameters] = useSearchParams();

    const [ordemProducao, setOrdemProducao] = useState<OrdemProducao>(new OrdemProducao());
    const [titulo, setTitulo] = useState<string>('Ordem de Produção');
    const [materiasPrimas, setMateriasPrimas] = useState<Produto[]>([]);
    const [materiasPrimasFiltradas, setMateriasPrimasFiltradas] = useState<Produto[]>([]);
    const [faseSelecionada, setFaseSelecionada] = useState<string>('PRODUTO_ACABADO');
    const [estagioSelecionadoQualidade, setEstagioSelecionadoQualidade] = useState<EstagioOP>(new EstagioOP());
    const [visibleDialogRelatorio, setVisibleDialogRelatorio] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        ordemProducaoService.getProdutos().then((response) => {
            setMateriasPrimas(response);
        }).catch((error) => {
            msgErro("Erro", 'Erro ao carregar estagios');
        });
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_COMPOSICAO_ESTAGIO_OP")) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
    }, [])

    function validar() {
        if (!ordemProducao.dataGeracao || ordemProducao.dataGeracao.toString() === "Invalid Date") {
            msgAlerta("Atenção", "Data de geração inválida");
            return false;
        }

        let seqRoteiro = 0;
        for (let i = 0; i < ordemProducao.componentesOp.length; i++) {
            if (!ordemProducao.componentesOp[i].estagioOP || ordemProducao.componentesOp[i].estagioOP?.id == 0) {
                msgAlerta("Atenção", "Estágio não selecionado para o componente " + (i + 1));
                return false;
            }
            if (!ordemProducao.componentesOp[i].componente) {
                msgAlerta("Atenção", "Produto não selecionado para o componente " + (i + 1));
                return false;
            }
            if (ordemProducao.componentesOp[i].qtPrevista <= 0) {
                msgAlerta("Atenção", "Quantidade inválida para o componente " + (i + 1));
                return false;
            }
            if ((ordemProducao.componentesOp[i].estagioOP?.sequencial || 0) > seqRoteiro) {
                seqRoteiro = ordemProducao.componentesOp[i].estagioOP?.sequencial || 0;
            }
            if (ordemProducao.componentesOp[i].componente?.unidadeMedida === "UN" && ordemProducao.componentesOp[i].qtPrevista % 1 != 0) {
                msgAlerta("Atenção", "Quantidade inválida para o componente " + (i + 1) + ". Para produtos em UN, a quantidade deve ser inteira.");
                return false;
            }

        }
        return true;
    }

    const rowGroupHeaderTemplate = (data: any) => {
        return (
            <tr style={{ fontWeight: 700 }}>
                {data.estagioOP ?
                    <>
                        <td colSpan={1} style={{ textAlign: 'left' }}>{data.estagioOP?.sequencial + " - "}</td>
                        <td colSpan={3} style={{ textAlign: 'left' }}>{data.estagioOP?.estagio.nome}</td>
                    </>
                    :
                    <td></td>
                }

            </tr>
        );
    }

    const dataTableHeaderTemplate = () => {
        return <ColumnGroup>
            <Row>
                <Column header="" rowSpan={2} colSpan={1} />
                <Column header="Estágio" rowSpan={2} colSpan={1} />
                <Column header="Sequencial" rowSpan={2} colSpan={1} />
                <Column header="Produto" rowSpan={1} colSpan={2} />
                <Column header="Qtd. Prev." rowSpan={2} colSpan={1} />
                <Column header="Uni. Med" rowSpan={2} colSpan={1} />
                <Column header="" rowSpan={2} colSpan={1} />
                <Column header="" rowSpan={2} colSpan={1} />
            </Row>
            <Row>
                <Column header="Código" colSpan={1} />
                <Column header="Nome" colSpan={1} />
            </Row>
        </ColumnGroup>
    }

    const botoesExtra = <>
        <Button label="Cancelar OP" onClick={() => { cancelarOP() }} style={{ marginLeft: 8 }} />
        <Button label="Liberar OP" onClick={() => { liberar() }} style={{ marginLeft: 8 }} />
    </>

    function cancelarOP() {
        confirmDialog({
            message: 'Deseja realmente cancelar a ordem de produção?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Sim",
            rejectLabel: "Não",
            accept: () => {
                cancelar()
            },
            reject: () => { },

        });
    }

    function cancelar() {
        ordemProducaoService.cancelar(ordemProducao.id).then((response) => {
            msgSucesso("Cancelada", 'Ordem de produção cancelada com sucesso');
            if (response) {
                setOrdemProducao(response);
            }
        }).catch((error) => {
            if (error.data && error.data.message) {
                msgAlerta("Atenção", error.data.message);
                return;
            }
            msgErro("Erro", 'Erro ao cancelar ordem de produção');
        });
    }

    function liberar() {
        ordemProducaoService.liberar(ordemProducao.id).then((response) => {
            msgSucesso("Liberada", 'Ordem de produção liberada com sucesso');
            if (response) {
                setOrdemProducao(response);
            }
        }).catch((error) => {
            if (error.data && error.data.message) {
                msgAlerta("Atenção", error.data.message);
                return;
            }
            msgErro("Erro", 'Erro ao liberar ordem de produção');
        });
    }

    const editorComponente = (options: any) => {
        return <AutoComplete
            disabled={!options.rowData.estagioOP}
            value={options.rowData.componente}
            placeholder="Selecione um Componente"
            style={{ width: '100%' }}
            field="nome"
            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
            suggestions={materiasPrimasFiltradas}
            completeMethod={(e) => {
                let filtered: Produto[] = produtoCompleteMethod(materiasPrimas, e.query);
                setMateriasPrimasFiltradas(filtered);
            }}
            onChange={(e) => {
                let opLocal = JSON.parse(JSON.stringify(ordemProducao));
                if (typeof e.target.value == "string") {
                    let prod = new Produto();
                    prod.nome = e.target.value;
                    opLocal.componentesOp[options.rowIndex].componente = prod;
                } else {
                    opLocal.componentesOp[options.rowIndex].componente = e.target.value;
                    let unimed = getUnidadeMedida(opLocal.componentesOp, options.rowData.estagioOP, options.rowIndex);
                    if (unimed !== e.target.value.unidadeMedida && unimed != equivalentes[e.target.value.unidadeMedida]) {
                        msgAlerta("Atenção", "Unidade de medida diferente");
                        return;
                    }
                }
                options.rowData['componente'] = opLocal.componentesOp[options.rowIndex].componente;

                setOrdemProducao(opLocal);
            }}

        />

    }

    const getUnidadeMedida = (componentes: ComponenteOP[], estagioOP: EstagioOP, indiceAtual: number) => {


        let componentesFiltrados = componentes.filter((item: ComponenteOP) => (item.estagioOP?.sequencial || 0) == estagioOP.sequencial);

        if (componentesFiltrados.length === 1) {
            return componentesFiltrados[0]?.componente?.unidadeMedida;
        }

        for (let i = 0; i < componentes.length; i++) {
            if (estagioOP.sequencial == componentes[i].estagioOP?.sequencial && i !== indiceAtual) {
                return componentes[i].componente?.unidadeMedida;
            }
        }
    }

    const equivalentes: Record<string, string> = {
        KG: "LT",
        LT: "KG"
    };

    const editorQuantidade = (options: any) => {
        return <InputNumber
            value={options.rowData[options.field]}
            minFractionDigits={isKgouLt(options.rowData.componente?.unidadeMedida || "") ? 1 : 0}
            maxFractionDigits={isKgouLt(options.rowData.componente?.unidadeMedida || "") ? 8 : 0}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData[options.field] = e.value;
                let opLocal = { ...ordemProducao };
                opLocal.componentesOp[options.rowIndex] = options.rowData;
                setOrdemProducao(opLocal);
            }}
            style={{ width: '100%' }} />;
    }

    const editorEstagio = (options: any) => {
        return <Dropdown
            value={options.rowData.estagioOP}
            options={ordemProducao.estagiosOp}
            optionLabel='estagio.nome'
            itemTemplate={(item: EstagioOP) => item.sequencial + " - " + item.estagio.nome}
            onChange={(e) => {

                let componentes = [...ordemProducao.componentesOp];
                options.rowData.sequencial = getNextSeq(e.target.value.sequencial);
                options.rowData['estagioOP'] = e.target.value;

                componentes[options.rowIndex] = options.rowData;
                componentes = reorderEstagios(componentes);
                componentes = reorderComponentes(componentes);

                let opLocal = { ...ordemProducao };
                opLocal.componentesOp = componentes;

                setOrdemProducao(opLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione um Estágio" />;
    }

    const getNextSeq = (seqEstagioOp: number) => {
        let seq = 0;
        ordemProducao.componentesOp.forEach((item: ComponenteOP) => {
            if (item.estagioOP && item.estagioOP.sequencial == seqEstagioOp) {
                if (item.sequencial > seq) {
                    seq = item.sequencial;
                }
            }
        });
        return seq + 1;
    }

    const reorderEstagios = (componentes: ComponenteOP[]) => {
        let listaLocal = [...componentes];
        listaLocal.sort((a, b) => {
            if ((a.estagioOP?.sequencial || 0) > (b.estagioOP?.sequencial || 0)) {
                return 1;
            }
            if ((a.estagioOP?.sequencial || 0) < (b.estagioOP?.sequencial || 0)) {
                return -1;
            }
            if (a.sequencial > b.sequencial) {
                return 1;
            }
            if (a.sequencial < b.sequencial) {
                return -1;
            }
            return 0;
        });
        return listaLocal;
    }

    const reorderComponentes = (componentes: ComponenteOP[]): ComponenteOP[] => {
        let seqRoteiro = 0;
        let seqComponente = 1;
        for (let i = 0; i < componentes.length; i++) {
            if (((componentes[i] as ComponenteOP).estagioOP?.sequencial || 0) > seqRoteiro) {
                seqRoteiro = (componentes[i] as ComponenteOP).estagioOP?.sequencial || 0;
                seqComponente = 1;
            } else {
                seqComponente++;
            }

            (componentes[i] as ComponenteOP).sequencial = seqComponente;
        }

        return componentes;
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    function relatorioEstagio(estagio: EstagioOP) {
        ordemProducaoService.getRelatorioEstagio(estagio.id).then((response) => {
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, estagio.ordemProducao.numero + " - " + estagio.estagio.nome + ".pdf");
        }).catch((error) => {
            msgErro("Erro", 'Erro ao gerar relatório');
        });
    }

    const headerDatatableEstagio =
        <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
            <div></div>
            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Estágios</span>
            <div >
                {editaRelatorios ? <Button
                    style={{ marginLeft: 8 }}
                    type="button"
                    label="Alterar relatórios"
                    onClick={() => {
                        setVisibleDialogRelatorio(true);

                    }}>

                </Button> : null}
            </div>
        </div>

    function editarDataFimOP() {
        startLoading();
        ordemProducaoService.editarDataFimOP(ordemProducao).then((data) => {
            stopLoading();
            msgSucesso(titulo, 'Data de fim da OP alterado com sucesso.');
        }).catch((error) => {
            stopLoading();
            msgSucesso(titulo, 'Erro ao alterar data de fim da OP.');
            console.error(error);
        })
    }


    return (

        <BaseCadastro
            model={ordemProducao} service={ordemProducaoService} setModel={(value: OrdemProducao) => setOrdemProducao(value)}
            validar={() => validar()} urlService="/ordemProducao" pathCadastro="/ordemProducao" tituloPagina={'Ordem de Producao'}
            botoesExtra={botoesExtra}
        >
            <Dialog visible={visibleDialogRelatorio}
                onHide={() => setVisibleDialogRelatorio(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_COMPOSICAO_ESTAGIO_OP" titulo="Relatório de estágio" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <TabView className="col-sm-12">
                    <TabPanel header="Dados gerais">
                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Número</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducao.numero + ""} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Produto</label>
                            <div className="col-sm-12">
                                <InputText required value={ordemProducao.produto.codigo || ""} readOnly style={{ width: '20%', marginRight: 10 }} />
                                <InputText required value={ordemProducao.produto.nome} readOnly style={{ width: '50%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Quantidade prevista</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducao.qtPrevista + " " + (ordemProducao.produto.unidadeMedida || "")} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Quantidade produzida</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducao.qtProduzida + " " + (ordemProducao.produto.unidadeMedida || "")} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Lote</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducao.lote} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Status</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducaoService.getStatus(ordemProducao.status)} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Usuário de geração</label>
                            <div className="col-sm-12">
                                <InputText value={ordemProducao.usuarioGeracao?.nome || ""} readOnly style={{ width: '20%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Data de geração</label>
                            <div className="col-sm-12">

                                <DateTimePicker
                                    value={dayjs(ordemProducao.dataGeracao)}
                                    ampm={false}
                                    format={"DD/MM/YYYY HH:mm"}
                                    onChange={value => {
                                        setOrdemProducao({ ...ordemProducao, dataGeracao: value?.toDate() || null })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div style={{ width: "20%", padding: 2, marginRight: 6 }}>
                                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Data de Inicio</label>
                                <div className="col-sm-12">
                                    <InputText value={converterDataHora(ordemProducao.dataInicio)} readOnly style={{ width: '100%' }} />
                                </div>
                            </div>
                            <div style={{ width: "20%", padding: 2 }}>
                                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Data de Fim</label>
                                <div className="col-sm-12">

                                    <DateTimePicker
                                        readOnly={ordemProducao.status == "FINALIZADA" ? false : true}
                                        value={dayjs(ordemProducao.dataFim)}
                                        ampm={false}
                                        format={"DD/MM/YYYY HH:mm"}
                                        onChange={value => {
                                            setOrdemProducao({ ...ordemProducao, dataFim: value?.toDate() || null })
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ width: "20%", padding: 2 }}>
                                <label style={{ width: '100%' }}></label>
                                <Button icon={<FontAwesomeIcon icon="edit" />} disabled={ordemProducao.status == "FINALIZADA" ? false : true}
                                    onClick={() => { editarDataFimOP() }} />
                            </div>

                        </div>

                        <div className="row">
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Data de validade</label>
                            <div className="col-sm-12">

                                <DatePicker
                                    value={dayjs(ordemProducao.dataValidade)}
                                    format={"DD/MM/YYYY"}
                                    onChange={value => {
                                        setOrdemProducao({ ...ordemProducao, dataValidade: value?.toDate() || null })
                                    }}
                                />
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel header="Estágios">
                        <div className="row">
                            <div className="col-sm-12">
                                <DataTable value={ordemProducao.estagiosOp} header={headerDatatableEstagio} emptyMessage="Nenhum registro encontrado">
                                    <Column field="sequencial" header="Sequencial" />
                                    <Column field="estagio.nome" header="Nome" />
                                    <Column field="dataHoraInicio" header="Data Início" body={(rowData) => converterDataHora(rowData.dataHoraInicio)} />
                                    <Column field="dataHoraFim" header="Data Fim" body={(rowData) => converterDataHora(rowData.dataHoraFim)} />
                                    <Column field="status" header="Status" body={(rowData) => ordemProducaoService.getStatusEstagio(rowData.status)} />
                                    <Column body={(rowData) => <Button onClick={() => { relatorioEstagio(rowData) }} label="Relatório" />} />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel header="Componentes">
                        <div className="row">
                            <div className="col-sm-12">
                                <BaseDataTableEdit
                                    lista={ordemProducao.componentesOp || []}
                                    setLista={(value: any) => setOrdemProducao({ ...ordemProducao, componentesOp: value })}
                                    tituloLista="Componentes da OP"
                                    getNewModel={() => new ComponenteOP()}
                                    dataKey="key"
                                    rowGroupMode="subheader"
                                    groupRowsBy="estagioOP.sequencial"
                                    scrollable
                                    scrollHeight='500px'
                                    reordable
                                    rowCancelDisabled={(rowData) => { return !rowData.componente?.codigo || !rowData.estagioOP?.estagio?.nome }}
                                    onRowReorder={(e) => {
                                        let seqRoteiro = 0;
                                        let seqComponente = 1;
                                        for (let i = 0; i < e.value.length; i++) {
                                            if (((e.value[i] as ComponenteOP).estagioOP?.sequencial || 0) < seqRoteiro) {
                                                console.log("movimentação inválida: " + (e.value[i] as ComponenteOP).estagioOP?.sequencial + " < " + seqRoteiro);
                                                return
                                            } else if (((e.value[i] as ComponenteOP).estagioOP?.sequencial || 0) > seqRoteiro) {
                                                seqRoteiro = (e.value[i] as ComponenteOP).estagioOP?.sequencial || 0;
                                                seqComponente = 1;
                                            } else {
                                                seqComponente++;
                                            }

                                            (e.value[i] as ComponenteOP).sequencial = seqComponente;
                                        }
                                        ordemProducao.componentesOp = e.value as ComponenteOP[];
                                        setOrdemProducao({ ...ordemProducao });
                                    }}
                                    onDeleteRow={(list) => {

                                        let sequencial = 1;
                                        let seqEstagio = 0;

                                        for (let i = 0; i < list.length; i++) {
                                            if (list[i].estagioOP?.sequencial != seqEstagio) {
                                                seqEstagio = list[i].estagioOP?.sequencial || 0;
                                                sequencial = 1;
                                            }

                                            list[i].sequencial = sequencial;
                                            sequencial++;
                                        }
                                    }}
                                    defaultSequencial={0}
                                    rowGroupHeaderTemplate={rowGroupHeaderTemplate} headerColumnGroup={dataTableHeaderTemplate()}>
                                    <Column rowReorder style={{ width: '3em' }} />
                                    <Column field="estagioOP.estagio.nome" header="Estágio" editor={editorEstagio} />
                                    <Column field="sequencial" header="Sequencial" style={{ width: 100 }} />
                                    <Column field="componente.codigo" header="Produto código" style={{ width: 200 }} editor={editorComponente} />
                                    <Column field="componente.nome" header="produto nome" />
                                    <Column field="qtPrevista" header="Qtd. Prev." style={{ width: 120 }} editor={editorQuantidade} />
                                    <Column field="componente.unidadeMedida" header="Uni. Med." style={{ width: 120 }} />
                                </BaseDataTableEdit>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Execuções de qualidade">
                        <div style={{ display: "flex", marginBottom: 24 }}>
                            <div style={{ display: "flex", flexDirection: "column", width: "20%", marginRight: 10 }} >
                                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Fase</label>
                                <div className="col-sm-12">
                                    <Dropdown value={faseSelecionada} options={ordemProducaoService.getFasesQualidade()}
                                        optionLabel="label" optionValue="value" style={{ width: '100%' }}
                                        onChange={(e) => { setFaseSelecionada(e.target.value) }}
                                    />
                                </div>
                            </div>
                            {faseSelecionada === "ESTAGIO_PRODUCAO" ?
                                <div style={{ display: "flex", flexDirection: "column", width: "20%" }}>
                                    <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Estágio</label>
                                    <div className="col-sm-12">
                                        <Dropdown value={estagioSelecionadoQualidade} options={ordemProducao.estagiosOp.filter((item: EstagioOP) => item.execucaoPlanoQualidade?.id)}
                                            optionLabel="estagio.nome" style={{ width: '100%' }}
                                            onChange={(e) => { setEstagioSelecionadoQualidade(e.target.value) }}
                                        />
                                    </div>
                                </div>

                                : null}
                        </div>

                        {faseSelecionada === "PRODUTO_ACABADO" && ordemProducao.execucaoPlanoQualidade ?
                            <ExecucaoPlano value={ordemProducao.execucaoPlanoQualidade} editable={false} onChange={(value) => { }} />

                            : null}

                        {faseSelecionada === "ESTAGIO_PRODUCAO" && estagioSelecionadoQualidade?.execucaoPlanoQualidade?.id ?
                            <ExecucaoPlano value={estagioSelecionadoQualidade.execucaoPlanoQualidade} editable={false} onChange={(value) => { }} />

                            : null}

                    </TabPanel>
                </TabView >
            </div >

        </BaseCadastro >
    )
}
